<template>
	<ul class="side_types">
		<li 
			v-for="v in list" 
			:key="v.id" 
			class="border_float_b"
			:class="{'active': activeId == v.id}"
			@click="handleItemClick(v.id)"
		>{{ v.name }}</li>
	</ul>
</template>

<script>
	export default{
		props: {
			list: {
				type: Array,
				default() { return []; }
			},
			activeId: {
				type: Number,
				default: -1
			}
		},
		methods: {
			// 点击每项
			handleItemClick(id) {
				this.$emit('onClick', id);
			}
		}
	}
</script>

<style>
	.app_article .side_types{ position: absolute;width: 150px;height: 100%;top: 0;left: 0;border-right: 1px solid #ccc;overflow-x: hidden;overflow-y: auto; }
	.app_article .side_types li{ position: relative;padding: 10px 20px;text-align: center;line-height: 40px;cursor: pointer; }
	.app_article .side_types .active{ background: #fff;color: #30a5ff; }
</style>
